<template>
  <v-app>
    <v-app-bar app color="green" dark>
      <v-toolbar-title class="mr-10">
        <h1 class="titleAdmin">Admin Dashboard</h1>
      </v-toolbar-title>

      <v-toolbar-items>
        <v-btn
          v-for="link of links"
          :key="link.name"
          :to="{ name: link.name }"
          text
        >
          {{ link.displayName }}
        </v-btn>
      </v-toolbar-items>

      <v-spacer />
      <v-toolbar-items>
        <v-btn text @click="logout"> Se Déconnecter </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <router-view class="adminContainer" />
  </v-app>
</template>

<script>
import { adminParsedRoutes } from "@/router/routes.const";
import { mapMutations } from "vuex";

export default {
  mounted() {
    if (this.$store.state.account.role === "ROLE_USER") {
      this.$router.push("/user");
    }
  },
  computed: {
    links() {
      return adminParsedRoutes;
    },
  },
  methods: {
    logout() {
      this.resetStore();

      this.$notify({
        group: "all",
        title: "Vous êtes déconnecté",
        type: "success",
        duration: 2500,
      });
    },
    ...mapMutations(["resetStore"]),
  },
};
</script>

<style>
.adminContainer {
  margin-top: 64px;
}

.titleAdmin {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
